import React from 'react';
import LayoutContent from './layout/Content';

import DanteStaffDocs from './components/DanteStaffDocs';

const Documentation = () => {
  return (
    <div>
      <LayoutContent>
        <DanteStaffDocs />
      </LayoutContent>
    </div>
  );
}

export default Documentation;



// WEBPACK FOOTER //
// ./src/docs/Documentation.js